/**
 * @module components/Trust
 * @description Brief §4.7 trust bar: beneath browsing (full) and inside the
 * cart (compact). One data source: config/page.ts TRUST_POINTS.
 */
import type { JSX } from "react";
import { TRUST_POINTS } from "../config/page";
import { Icon } from "./Icons";
import "./Trust.css";

/** The trust points list. `compact` = one-line items for the cart. */
export function TrustList({ compact = false }: { compact?: boolean }): JSX.Element {
    return (
        <ul className={`trust-list${compact ? " trust-list--compact" : ""}`}>
            {TRUST_POINTS.map((p) => (
                <li key={p.title} className="trust-list__item">
                    <span className="trust-list__icon"><Icon name={p.icon} size={compact ? 16 : 26} /></span>
                    <span>
                        <strong>{p.title}</strong>
                        {!compact && <span className="trust-list__body">{p.body}</span>}
                    </span>
                </li>
            ))}
        </ul>
    );
}

/** Full-width trust section beneath the browse results. */
export function TrustSection(): JSX.Element {
    return (
        <section className="trust" aria-labelledby="trust-title">
            <div className="container">
                <h2 id="trust-title" className="visually-hidden">Why you can give with confidence</h2>
                <TrustList />
            </div>
        </section>
    );
}
